<div class="header-bar" *ngIf="campaign">
  <div class="header-left">
    <div class="header-text">{{ campaign.name }}</div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button mat-stroked-button color="lightGreen"
            *ngIf="(canSend$ | async) && sendgridEnabled && campaign.status === 'generation_complete'"
            (click)="openSendDialog()" matTooltip="Send Campaign">Send Campaign</button>
    <button mat-button color="lightGreen" [matMenuTriggerFor]="downloadMenu" [disabled]="campaign.status !== 'generation_complete' && campaign.status !== 'send_complete'" matTooltip="Download">Download Email Content</button>
    <mat-menu #downloadMenu="matMenu">
      <button mat-menu-item (click)="download('csv')" matTooltip="Download CSV (.zip)">CSV (.zip)</button>
      <button mat-menu-item (click)="download('xlsx')" matTooltip="Download XLSX (.zip)">XLSX (.zip)</button>
      <button mat-menu-item (click)="download('eml')" matTooltip="Download EML (.zip)">EML (.zip)</button>
    </mat-menu>
  </div>
</div>

<div class="campaigns" *ngIf="!isLoading && campaign; else loadingTpl">
  <div class="container campaigns-container">
    <div class="container-content">

      <div class="summary three-col">
        <div class="col left">
          <div class="summary-item"><strong>Status:</strong> {{ campaign.status | statusHumanize }}</div>
          <div class="summary-item"><strong>Total Recipients:</strong> {{ campaign.total_recipients || 0 }}</div>
          <div class="summary-item"><strong>Generated:</strong> {{ campaign.generated_count || 0 }}</div>
          <div class="summary-item" *ngIf="sendgridEnabled"><strong>Sent:</strong> {{ campaign.sent_count || 0 }}</div>
        </div>
        <div class="col center">
          <div class="summary-item"><strong>Created:</strong> {{ campaign.created_at | date:'short' }}</div>
          <div class="summary-item" *ngIf="campaign.created_by_user"><strong>Created By:</strong> {{ campaign.created_by_user.first_name }} {{ campaign.created_by_user.last_name }} <span class="muted">({{ campaign.created_by_user.email }})</span></div>
        </div>
        <div class="col right">
          <div class="summary-item"><strong>Updated:</strong> {{ campaign.updated_at | date:'short' }}</div>
          <div class="summary-item" *ngIf="campaign.updated_by_user"><strong>Updated By:</strong> {{ campaign.updated_by_user.first_name }} {{ campaign.updated_by_user.last_name }} <span class="muted">({{ campaign.updated_by_user.email }})</span></div>
        </div>
      </div>

      <table mat-table [dataSource]="rows" class="mat-table">
        <ng-container matColumnDef="generated_subject">
          <th mat-header-cell *matHeaderCellDef>Subject</th>
          <td mat-cell *matCellDef="let r"><div class="subject-cell">{{ r.generated_subject || 'Your Personalized Offer' }}</div></td>
        </ng-container>

        <ng-container matColumnDef="recipient">
          <th mat-header-cell *matHeaderCellDef>Recipient</th>
          <td mat-cell *matCellDef="let r">{{ r.first_name }} {{ r.last_name }} <span class="muted" *ngIf="r.email">({{ r.email }})</span></td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let r">{{ r.created_at | date: 'short' }}</td>
        </ng-container>

        <ng-container matColumnDef="updated_at">
          <th mat-header-cell *matHeaderCellDef>Updated</th>
          <td mat-cell *matCellDef="let r">{{ r.updated_at ? (r.updated_at | date: 'short') : '' }}</td>
        </ng-container>

        <ng-container matColumnDef="updated_by">
          <th mat-header-cell *matHeaderCellDef>Updated By</th>
          <td mat-cell *matCellDef="let r">
            <ng-container *ngIf="r.updated_by_first_name || r.updated_by_last_name || r.updated_by_email; else emptyUpdatedBy">
              {{ r.updated_by_first_name || '' }} {{ r.updated_by_last_name || '' }}
              <span class="muted" *ngIf="r.updated_by_email">({{ r.updated_by_email }})</span>
            </ng-container>
            <ng-template #emptyUpdatedBy></ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions-header">Actions</th>
          <td mat-cell *matCellDef="let r" class="options-cell">
            <button mat-icon-button aria-label="View" (click)="openPreview(r)"><mat-icon>visibility</mat-icon></button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>
      </table>

      <mat-paginator [length]="count" [pageIndex]="page" [pageSize]="perPage" [pageSizeOptions]="[25,50,100]" (page)="pageChange($event)" showFirstLastButtons></mat-paginator>

    </div>
  </div>
</div>

<ng-template #loadingTpl>
  <div class="loading">Loading…</div>
</ng-template>


